export default class StuffsheetElement {
  constructor(options) {
    this.templates = {
      stuffsheet_editor : "<div class='row-fluid editor-add-stuffsheet-wrapper'>" +
                            "<div class='editor-add-stuffsheet-pc-type btn-group'>" +
                               "<button type='button' value='c' class='editor-add-stuffsheet-pc-component btn btn-component active'>Component</button>" +
                               "<button type='button' value='p' class='editor-add-stuffsheet-pc-product btn btn-product'>Product</button>" +
                            "</div>" +
                            "<div class='editor-stuffsheet-dropdown-wrapper'>" +
                            "</div>" +
                            "<div class='editor-add-stuffsheet-qty-label'>Qty: </div><input type='number' name='stuffsheet_qty' id='editor-add-stuffsheet-qty' class='build-input editor-add-stuffsheet-qty' value='1' /><div class='clear'></div>" +
                            "<div class='editor-add-stuffsheet-name-label'>Name: </div><input type='text' name='stuffsheet_name' id='editor-add-stuffsheet-name' class='build-input editor-add-stuffsheet-name' /><div class='clear'></div>" +
                            "<div class='editor-buttons'>" +
                              "<button class='editor-add-stuffsheet-delete delete'>Delete</button>" +
                              "<button class='editor-add-stuffsheet-cancel cancel'>Cancel</button>" +
                              "<button class='editor-add-stuffsheet-submit save'>Save</button>" +
                            "</div>" +
                            "</div>",
      stuffsheet_element : '<div class="element row-fluid stuffsheet-element build-stuffsheet">' +
                               'QTY: <div class="build-stuffsheet-qty"></div>' +
                               '<div class="build-stuffsheet-pc-id"></div>' +
                               'Name: <div class="build-stuffsheet-name"></div>' +
                           '</div>'
    }

    this.options = options;

    this.learnEditor = options.editor ? options.editor : null;

    this.editor_enabled = false;
    this.saved_qty = '';
    this.saved_pc_id = '';
    this.activeElementId;
    this.activePosition;

    this.init_stuffsheet();
  }

  /* listens for the "stuffsheet" button click, and adds the stuffsheet editor. */
  init_stuffsheet() {
    $(document).on('click', '.add-build-stuffsheet', $.proxy(this.append_stuffsheet, this));
    $(document).on('click', '.build-stuffsheet', $.proxy(this.edit_existing_stuffsheet, this));
  }

  shouldShowButton() {
    return gon.system === "internal_learn";
  }

  addButtonTemplate() {
    return '<a class="add-build-stuffsheet" href="#"><i class="fa fa-list-ol"></i> Stuffsheet</a>';
  }

  append_stuffsheet(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $stuffsheet_editor = $(this.templates.stuffsheet_editor);
    var $element = $(event.target).closest('.button-bar, .bottom-button-bar');
    $element.replaceWith($stuffsheet_editor);


    this.learnEditor.editing();
    this.enable_stuffsheet_editor($stuffsheet_editor);
  }


  edit_existing_stuffsheet(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    this.activeElementId = $(event.currentTarget).attr('id');
    this.activePosition = $(event.currentTarget).data('position');

    var qty = $('.build-stuffsheet-qty', event.currentTarget).text();
    //var pc_id = $('.build-stuffsheet-pc-id', this).text().replace('CID: ', 'c').replace('PID: ', 'p');
    var pc_id = $('.build-stuffsheet-pc-id', event.currentTarget).attr('pc_id');
    var name = $('.build-stuffsheet-name', event.currentTarget).text();
    var gen_id = pc_id.replace('c', '').replace('p', '');
    var $stuffsheet_editor = $(this.templates.stuffsheet_editor);
    // set dropdown to products if its a products row
    if( pc_id.indexOf('p') !== -1){
      $stuffsheet_editor.find('.editor-add-stuffsheet-pc-component').removeClass('active');
      $stuffsheet_editor.find('.editor-add-stuffsheet-pc-product').addClass('active');
    }

    this.saved_qty = qty;
    this.saved_pc_id = pc_id;
    this.saved_name = name;

    $stuffsheet_editor.find('.editor-add-stuffsheet-qty').val(qty);
    $stuffsheet_editor.find('.editor-add-stuffsheet-name').val(name);
    $stuffsheet_editor.data('pc_id', pc_id);

    $(event.currentTarget).replaceWith($stuffsheet_editor);

    this.learnEditor.center_in_view($('.editor-add-stuffsheet-wrapper'));
    this.learnEditor.editing();
    this.enable_stuffsheet_editor($stuffsheet_editor);
  }


  set_dropdown($stuffsheet_editor, pc_type) {
//  pc_type = $stuffsheet_editor.find('.editor-add-stuffsheet-pc-type .active').val();


    var $c_dropdown = $('<select name="gen_id" class="editor-add-stuffsheet-dropdown select2 admin-select"></select>');
    $(gon.components).each( function(component_index, component_info){
      var fullname = component_info['name'];
      fullname = fullname.replace(/(<([^>]+)>)/ig,"");
      $c_dropdown.append( $('<option value="'+component_info['id']+'" fullname="'+ fullname+'">'+component_info['id'] + ' --- ' + fullname + '</option>') );
    });
    var $p_dropdown = $('<select name="gen_id" class="editor-add-stuffsheet-dropdown select2 admin-select"></select>');
    $(gon.products).each( function(product_index, product_info){
      var fullname = product_info['name'];
      fullname = fullname.replace(/(<([^>]+)>)/ig,"");
      $p_dropdown.append( $('<option value="'+product_info['id']+'" fullname="'+fullname +'">'+product_info['id'] + ' --- ' + fullname + '</option>'));
    });

    $stuffsheet_editor.find('.editor-stuffsheet-dropdown-wrapper').empty();

    if(pc_type == 'c'){
      $stuffsheet_editor.find('.editor-stuffsheet-dropdown-wrapper').append('<div class="cid-label">SKU: </div>');
      $stuffsheet_editor.find('.editor-stuffsheet-dropdown-wrapper').append($c_dropdown);

      $stuffsheet_editor.find('.editor-add-stuffsheet-pc-product').removeClass('active');
      $stuffsheet_editor.find('.editor-add-stuffsheet-pc-component').addClass('active');
    }
    else if(pc_type == 'p'){
      $stuffsheet_editor.find('.editor-stuffsheet-dropdown-wrapper').append('<span class="pid-label">PID: </span>');
      $stuffsheet_editor.find('.editor-stuffsheet-dropdown-wrapper').append($p_dropdown);

      $stuffsheet_editor.find('.editor-add-stuffsheet-pc-component').removeClass('active');
      $stuffsheet_editor.find('.editor-add-stuffsheet-pc-product').addClass('active');
    }
    if($stuffsheet_editor.data("pc_id" ) !== undefined){
      var gen_id = $stuffsheet_editor.data("pc_id").replace('p', '').replace('c', '').trim();
      $stuffsheet_editor.find(".editor-add-stuffsheet-dropdown option[value='"+gen_id+"']").attr('selected', 'selected');
    }

    $(document).on('change', '.editor-add-stuffsheet-dropdown', function(){
      $stuffsheet_editor.find('.editor-add-stuffsheet-name').val($stuffsheet_editor.children('option:selected').attr('fullname'));
    });

    $('.select2').select2({
      width: 'resolve'
    })
  }

  enable_stuffsheet_editor($stuffsheet_editor) {

    this.set_dropdown($stuffsheet_editor, 'c');

    $(document).on('click', '.editor-add-stuffsheet-pc-component', $.proxy(this.set_dropdown, this, $stuffsheet_editor, 'c'));
    $(document).on('click', '.editor-add-stuffsheet-pc-product', $.proxy(this.set_dropdown, this, $stuffsheet_editor, 'p'));

    $(document).on('click', '.editor-add-stuffsheet-submit', $.proxy(this.save_stuffsheet_handler, this));
    $(document).on('click', '.editor-add-stuffsheet-cancel', $.proxy(this.cancel_stuffsheet_handler, this));
    $(document).on('click', '.editor-add-stuffsheet-delete', $.proxy(this.delete_stuffsheet_handler, this));
  }

  stuffsheet_editor_modified() {
    $(document).off('click', '.editor-add-stuffsheet-submit');
    $(document).off('click', '.editor-add-stuffsheet-cancel');
    $(document).off('click', '.editor-add-stuffsheet-delete');

    this.learnEditor.save_page("Before Stuffsheet Modified");
  }

  save_stuffsheet_handler(event) {
    event.preventDefault();

    var pc_type = $('.editor-add-stuffsheet-pc-type .active').val();
    var gen_id = $('.editor-add-stuffsheet-dropdown').val();
    var pc_id = pc_type + gen_id;
    var qty = $('.editor-add-stuffsheet-qty').val();
    var name = $('.editor-add-stuffsheet-name').val();

    this.create_stuffsheet_element(qty, pc_id, name);
    this.stuffsheet_editor_modified();
  }

  cancel_stuffsheet_handler(event) {
    event.preventDefault();
    if (this.saved_qty) {
      this.create_stuffsheet_element(this.saved_qty, this.saved_pc_id, this.saved_name);
    } else {
      $('.editor-add-stuffsheet-wrapper').remove();
    }
  }

  delete_stuffsheet_handler(event) {
    event.preventDefault();

    this.activeElementId = "";
    self.activePosition = "";
    $('.editor-add-stuffsheet-wrapper').remove();

    this.stuffsheet_editor_modified();
  }

  create_stuffsheet_element(qty, pc_id, name) {
    var $stuffsheet_element = $(this.templates.stuffsheet_element).attr('id', (this.activeElementId || "")).data('position', this.activePosition);
    this.activeElementId = "";
    self.activePosition = "";

    $stuffsheet_element.find('.build-stuffsheet-qty').text(qty);
    $stuffsheet_element.find('.build-stuffsheet-pc-id').text(pc_id.replace('p', ' PID: ').replace('c', ' SKU: '));
    $stuffsheet_element.find('.build-stuffsheet-pc-id').attr('pc_id', pc_id);
    $stuffsheet_element.find('.build-stuffsheet-name').text(name);

    $('.editor-add-stuffsheet-wrapper').replaceWith($stuffsheet_element);
  }
}
